import {
  Button,
  Modal,
  ModalActions,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalTitle,
} from "@onengine/component-library";

import { useFileManager, useFileManagerUI } from "@/components/core/FileManager";
import { getIconConfig } from "@/components/core/FileManager/components/FileManagerItemCard/FileManagerItemCard.tsx";
import { notifications } from "@mantine/notifications";
import { modalBody } from "@/components/features/FileManager/Modals/modals.style.ts";

import styles from "./ApprovalModal.module.scss";

export function ApprovalModal() {
  const { approve } = useFileManager();
  const { approvalTarget, closeApproval } = useFileManagerUI();

  const items = approvalTarget?.items ?? [];
  const singleItem = items.length === 1 ? items[0] : null;

  const iconCfg = singleItem
    ? getIconConfig({
        ...singleItem,
        parentId: null,
        s3Key: null,
        contentType: null,
        fileSize: null,
        tags: [],
        childCount: 0,
        createdAt: "",
        updatedAt: "",
      })
    : null;

  function handleApprove(action: "move" | "copy") {
    if (!approvalTarget) return;
    approve(
      { items: approvalTarget.items, action },
      {
        onSuccess: closeApproval,
        onError: () => {
          notifications.show({
            title: "Approval failed",
            message: "Could not mark for approval. Please try again.",
            color: "red",
            autoClose: 4000,
          });
        },
      },
    );
  }

  const itemLabel = singleItem ? `"${singleItem.name}"` : `${items.length} files`;

  return (
    <Modal open={!!approvalTarget} onClose={closeApproval}>
      <ModalContent>
        <ModalTitle>Mark for Approval</ModalTitle>
        <ModalBody>
          <div style={modalBody}>
            {iconCfg && singleItem && (
              <div className={styles.itemPreview}>
                <iconCfg.Icon size={20} color={iconCfg.color} />
                <p className={styles.itemName}>{singleItem.name}</p>
              </div>
            )}
            {!singleItem && items.length > 0 && (
              <p className={styles.itemName}>
                <strong>{items.length} files</strong> selected.
              </p>
            )}
            <p className={styles.prompt}>
              How would you like to add {itemLabel} to &ldquo;Approved to share with client&rdquo;?
            </p>
            <p className={styles.hint}>
              <strong>Move</strong> removes {singleItem ? "it" : "them"} from the current folder.{" "}
              <strong>Copy</strong> keeps the original and adds {singleItem ? "a copy" : "copies"}{" "}
              to the approved folder.
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <ModalActions position={"right"}>
            <Button variant="neutral-secondary" onClick={closeApproval}>
              Cancel
            </Button>
            <Button variant="neutral-secondary" onClick={() => handleApprove("move")}>
              Move to Approved
            </Button>
            <Button variant="primary" onClick={() => handleApprove("copy")}>
              Copy to Approved
            </Button>
          </ModalActions>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
